import TrackableEvent from 'automation-contextual-components/_internal/tracking/TrackableEvent';
import { CREATE_CONTEXTUAL_TEMPLATE, CREATE_CONTEXTUAL_WORKFLOW, DELETE_CONTEXTUAL_WORKFLOW, EXTERNAL_NAVIGATION, UPDATE_CONTEXTUAL_WORKFLOW, VIEW_KNOWLEDGE_BASE_ARTICLE, VIEWED_COMPONENT, VIEWED_REFERENCE_TYPE, RELATED_WORKFLOWS_TABLE_INTERACTION } from 'automation-contextual-components/_internal/tracking/TrackingEventKeys';
const Trackables = {
  CREATE_CONTEXTUAL_TEMPLATE: 'CREATE_CONTEXTUAL_TEMPLATE',
  CREATE_CONTEXTUAL_WORKFLOW: 'CREATE_CONTEXTUAL_WORKFLOW',
  CREATE_RECOMMENDED_CONTEXTUAL_WORKFLOW: 'CREATE_RECOMMENDED_CONTEXTUAL_WORKFLOW',
  DELETE_CONTEXTUAL_WORKFLOW: 'DELETE_CONTEXTUAL_WORKFLOW',
  DISABLE_CONTEXTUAL_WORKFLOW: 'DISABLE_CONTEXTUAL_WORKFLOW',
  EDIT_CONTEXTUAL_WORKFLOW_NAME: 'EDIT_CONTEXTUAL_WORKFLOW_NAME',
  ENABLE_CONTEXTUAL_WORKFLOW: 'ENABLE_CONTEXTUAL_WORKFLOW',
  NAVIGATE_TO_TEMPLATE_PREVIEW: 'NAVIGATE_TO_TEMPLATE_PREVIEW',
  NAVIGATE_TO_TEMPLATE_LIBRARY: 'NAVIGATE_TO_TEMPLATE_LIBRARY',
  NAVIGATE_TO_WORKFLOW: 'NAVIGATE_TO_WORKFLOW',
  NAVIGATE_TO_WORKFLOWS_APP: 'NAVIGATE_TO_WORKFLOWS_APP',
  OPEN_UPGRADE_MODAL: 'OPEN_UPGRADE_MODAL',
  SORT_RELATED_WORKFLOWS_TABLE: 'SORT_RELATED_WORKFLOWS_TABLE',
  VIEW_KNOWLEDGE_BASE_ARTICLE: 'VIEW_KNOWLEDGE_BASE_ARTICLE',
  VIEWED_COMPONENT: 'VIEWED_COMPONENT',
  VIEWED_REFERENCE_TYPE: 'VIEWED_REFERENCE_TYPE'
};
const TrackablesDictionary = {
  [Trackables.CREATE_CONTEXTUAL_TEMPLATE]: {
    eventType: CREATE_CONTEXTUAL_TEMPLATE,
    eventProps: {
      action: 'Create workflow from contextual template'
    }
  },
  [Trackables.CREATE_RECOMMENDED_CONTEXTUAL_WORKFLOW]: {
    eventType: CREATE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Create recommended contextual workflow'
    }
  },
  [Trackables.CREATE_CONTEXTUAL_WORKFLOW]: {
    eventType: CREATE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Create contextual workflow'
    }
  },
  [Trackables.DELETE_CONTEXTUAL_WORKFLOW]: {
    eventType: DELETE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Delete contextual workflow'
    }
  },
  [Trackables.DISABLE_CONTEXTUAL_WORKFLOW]: {
    eventType: UPDATE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Disabled contextual workflow'
    }
  },
  [Trackables.EDIT_CONTEXTUAL_WORKFLOW_NAME]: {
    eventType: UPDATE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Edit contextual workflow name'
    }
  },
  [Trackables.ENABLE_CONTEXTUAL_WORKFLOW]: {
    eventType: UPDATE_CONTEXTUAL_WORKFLOW,
    eventProps: {
      action: 'Enabled contextual workflow'
    }
  },
  [Trackables.NAVIGATE_TO_TEMPLATE_PREVIEW]: {
    eventType: EXTERNAL_NAVIGATION,
    eventProps: {
      action: 'Navigate to template preview'
    }
  },
  [Trackables.NAVIGATE_TO_TEMPLATE_LIBRARY]: {
    eventType: EXTERNAL_NAVIGATION,
    eventProps: {
      action: 'Navigate to template library'
    }
  },
  [Trackables.NAVIGATE_TO_WORKFLOW]: {
    eventType: EXTERNAL_NAVIGATION,
    eventProps: {
      action: 'Navigate to workflow from workflow detail'
    }
  },
  [Trackables.NAVIGATE_TO_WORKFLOWS_APP]: {
    eventType: EXTERNAL_NAVIGATION,
    eventProps: {
      action: 'Navigate to worfklows app'
    }
  },
  [Trackables.OPEN_UPGRADE_MODAL]: {
    eventType: EXTERNAL_NAVIGATION,
    eventProps: {
      action: 'Open upgrade modal'
    }
  },
  [Trackables.SORT_RELATED_WORKFLOWS_TABLE]: {
    eventType: RELATED_WORKFLOWS_TABLE_INTERACTION,
    eventProps: {
      action: 'Clicked to sort the related workflows table'
    }
  },
  [Trackables.VIEW_KNOWLEDGE_BASE_ARTICLE]: {
    eventType: VIEW_KNOWLEDGE_BASE_ARTICLE,
    eventProps: {
      action: 'View knowledge base article'
    }
  },
  [Trackables.VIEWED_REFERENCE_TYPE]: {
    eventType: VIEWED_REFERENCE_TYPE,
    eventProps: {
      action: 'viewed a reference'
    }
  },
  [Trackables.VIEWED_COMPONENT]: {
    eventType: VIEWED_COMPONENT,
    eventProps: {
      action: 'viewed a component'
    }
  }
}; // Matching possible event definition property types https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/event-definition-spec.html#properties

export const TrackableDefinitions = Object.keys(Trackables).reduce((defs, trackable) => {
  if (TrackablesDictionary[trackable]) {
    const {
      eventType,
      eventProps
    } = TrackablesDictionary[trackable];

    defs[trackable] = extraEventProps => new TrackableEvent({
      eventType,
      eventProps: Object.assign({}, eventProps, {}, extraEventProps)
    });
  }

  return defs;
}, {});
export default Trackables;